import { observable, computed } from 'mobx'

import Connection from './connection'
import PaginatedStore from './paginated_store'
import api from '../api'

export default class TeamsStore extends PaginatedStore {
  constructor(scope) {
    super(new Connection('teams', scope))
  }

  @observable users

  @computed get usersLoaded() {
    return this.users !== undefined
  }

  loadUsers(team_id) {
    return api.get('users', { params: { team_id } })
      .then(resp => resp.data)
      .then(data => this.users = data)
  }

  startTrial(team_id, plan, trial_period_days) {
    return api.post('licenses', { team_id, plan, trial_period_days }).then(resp => resp.data)
  }

  activateDirectBillLicense(team_id, plan) {
    return api.post('licenses', { team_id, plan }).then(resp => resp.data)
  }

  updateLicense(team_id, params) {
    const license = this.findById(team_id).license
    return api.put(`licenses/${license.id}`, params)
      .then(() => this.load(team_id))
  }

  updateResellerTeam(team_id, reseller_team_id) {
    return api.put(`teams/${team_id}`, { reseller_team_id })
      .then(() => this.load(team_id))
  }

  /*
   * Override update to nullify mls. We never need to send it back,
   * and it's too large, causing 413 errors.
   *
   * Fix for #15469
   */
  update(data) {
    data.mls = null
    return super.update(data)
  }
}



// WEBPACK FOOTER //
// client/stores/teams.js